<!-- 车站管理 -->
<template>
  <div>
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @row-save="rowSave"
      @row-update="rowUpdate"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      :beforeOpen="beforeOpen"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
    >
    </avue-crud>
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { getList, add, update, remove } from "./api";
export default {
  mixins: [crudMixins],
  data() {
    return {
      apiConfig: { getList, add, update, remove },
      option: {
        ...this.$store.state.publicOption,
        column: [
          {
            label: "类型",
            prop: "safeyType",
            type: "select",
            search: true,
            hide: false,
            showColumn: true,
            addDisplay: true,
            editDisplay: true,
            viewDisplay: true,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=safeType",
            dataType: "number",
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            rules: [
              {
                required: true,
                message: "请选择类型",
                trigger: "blur",
              },
            ],
          },
          {
            label: "类型编码",
            prop: "typeCode",
            maxlength: 10,
            overHidden: true, // 表格超出隐藏
            rules: [
              {
                required: true,
                message: "请输入类型编码",
                trigger: "blur",
              },
            ],
          },
          {
            label: "类型名称",
            prop: "typeName",
            maxlength: 60,
            search: true,
            rules: [
              {
                required: true,
                message: "请输入检查类型名称",
                trigger: "blur",
              },
            ],
          },
        ],
      },
    };
  },
};
</script>
<style scoped lang="scss"></style>
